/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/jsx-props-no-spreading */

import clsx from "clsx";
import { useRouter } from "components/hooks";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

interface TabProps {
  children: React.ReactNode;
  active?: number;
  style?: React.CSSProperties;
  className?: string;
  activeTabIndicatorColor?: string;
  fullWidthTabs?: boolean;
  fullBorder?: boolean;
  borderWhite?: boolean;
}
interface TabPanProps {
  children: any;
  style?: React.CSSProperties;
  className?: string;
  tab: string | number;
}

function Tab({
  children,
  active = 0,
  style,
  className,
  activeTabIndicatorColor,
  fullWidthTabs,
  fullBorder = false,
  borderWhite = false,
}: TabProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { query } = useRouter();
  const [activeTab, setActiveTab] = useState(active);
  const [tabData, setTabData] = useState<any>([]);

  useEffect(() => {
    if (query.tab && tabData.length) {
      // @ts-ignore
      const activeTab = tabData.findIndex(({ tab }) => tab === query.tab);
      if (activeTab) setActiveTab(activeTab);
    }
  }, [tabData]);

  useEffect(() => {
    const data = [] as any;
    React.Children.forEach(children, (element) => {
      if (!React.isValidElement(element)) return;
      const {
        props: { tab, children, ...restProps },
      } = element;
      data.push({ tab, children, ...restProps });
    });
    setTabData(data);
  }, [children]);

  useEffect(() => {
    const tab = tabData[activeTab]?.tab;

    if (tab) {
      searchParams.set("tab", tab);
      setSearchParams(searchParams, {
        replace: true,
      });
    }
  }, [activeTab]);

  return (
    <div>
      <ol style={style} className={clsx("flex list-none gap-4 2xl:gap-6", className)}>
        {tabData.map(({ tab, children, ...restProps }: any, index: number) =>
          !activeTabIndicatorColor ? (
            <li
              key={`tab${tab}`}
              className={clsx(
                "cursor-pointer font-sora text-xs font-semibold leading-6 text-white 2xl:text-sm",
                activeTab === index
                  ? `border-b-4 ${borderWhite ? "border-white" : "border-secondary"}`
                  : "text-opacity-60",
                fullWidthTabs && "flex-1 justify-center",
              )}
              style={
                fullBorder
                  ? {}
                  : {
                      borderImage:
                        activeTab === index ? "linear-gradient(to right, #B58D8C 50%, transparent 50%) 100% 1" : "none",
                    }
              }
            >
              <div onClick={() => setActiveTab(index)} {...restProps}>
                {tab}
              </div>
            </li>
          ) : (
            <li
              key={`tab${tab}`}
              style={{
                borderBottom: activeTab === index ? clsx("2px solid", activeTabIndicatorColor) : "",
                color: activeTab === index ? `${activeTabIndicatorColor}` : "",
                borderImage:
                  activeTab === index ? "linear-gradient(to right, #000 50%, transparent 50%) 100% 1" : "none",
              }}
              className={clsx("cursor-pointer", activeTab === index && "font-sora font-bold")}
            >
              <div onClick={() => setActiveTab(index)} {...restProps}>
                {tab}
              </div>
            </li>
          ),
        )}
      </ol>
      <div>{tabData[activeTab] && tabData[activeTab].children}</div>
    </div>
  );
}

const TabPane = ({ children }: TabPanProps) => children;
Tab.TabPane = TabPane;

export default Tab;
